import axiosInstance from "@/utils/axiosInstance";

const baseUrl: string = "api/connectors/urmet";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getLotsByBuildingUuid({commit}, payload: {
    buildingUuid: string,
  }): Promise<any> {
    return axiosInstance.get(`${baseUrl}/getLotsList/sitId/${payload.buildingUuid}`, {
    }).then((data) => data.data);
  },
  async getBadgesListByLotId({commit}, payload: {
    buildingUuid: string,
    lotId: number,
  }): Promise<any> {
    return axiosInstance.get(`${baseUrl}/getBadgesList/sitId/${payload.buildingUuid}/lotId/${payload.lotId}`, {
    }).then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
